/*
 * UMM 21-Day Mantra Draw (Oct 2026)
 * <umm-mantra-draw>  one card a day from the 21-Day Sacred Bathing Rituals Deck.
 * <umm-mantra-float> sitewide "Draw Today's Mantra" tab and pop-up.
 * Fires window event 'umm:mantra-drawn' (detail: card, week, mantra, question) for Digioh.
 */
(function () {
  if (window.UMMMantra) return;

  var WEEKS = [
    { name: 'Week 1: Return to Self', line: 'A week of grounding, reconnection, and gently turning inward.' },
    { name: 'Week 2: Renewal & Restoration', line: 'A week of gentle renewal, honoring your rhythms, and leaning into rest.' },
    { name: 'Week 3: Reclamation & Radiance', line: 'A week of awakening, reclaiming your power, and radiating your truth.' }
  ];
  var CARDS = [
    ['I return to myself.', 'Where in my life have I drifted away from myself, and how can I return today?'],
    ['I release what no longer serves.', 'What am I still holding onto that no longer nourishes me?'],
    ['I am worthy of care.', 'In what ways can I offer myself deeper care and tenderness right now?'],
    ['My breath grounds me.', 'When was the last time I truly felt anchored in my breath?'],
    ['My skin is a sacred boundary.', 'What boundaries, physical, emotional, or energetic, need my honoring today?'],
    ['I honor the wisdom of my body.', 'What is my body trying to tell me? Am I ready to listen?'],
    ['I soften into stillness.', 'Where can I allow more softness, quiet, or space in my day?'],
    ['I allow space for renewal.', 'What do I need to let go of in order to welcome renewal?'],
    ['I am safe in my body.', 'What makes me feel safe and supported in my skin?'],
    ['I welcome rest as medicine.', 'How can I prioritize rest today without guilt?'],
    ['I trust the rhythm of nature.', 'Where am I resisting flow and how can I align instead?'],
    ['I embrace all of me: the light and shadow.', 'What part of myself needs more compassion and acceptance today?'],
    ['I nourish myself deeply.', 'What does true nourishment look like for me: mind, body, and soul?'],
    ['I am held by the elements.', 'Which element, earth, water, fire, air, or space, do I most need right now?'],
    ['I am present in this moment.', 'What can I feel, sense, and notice right here, right now?'],
    ['I listen to my inner voice.', 'What is my intuition whispering to me today?'],
    ['I am rooted. I am radiant.', 'What anchors me, and what allows my light to shine?'],
    ['I cleanse with intention.', 'What do I wish to energetically clear or release today?'],
    ['I surrender to flow.', 'Where can I soften control and trust the unfolding?'],
    ['I reclaim my energy.', 'What energy of mine needs to return home to me now?'],
    ['I begin again.', 'What small, loving step forward can I take in this new beginning?']
  ];
  var KEY = 'umm_mantra_v1';

  function today() {
    var d = new Date();
    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
  }
  function load() {
    try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
  }
  function save(s) {
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) { /* private mode */ }
  }
  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function track(name, detail) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, detail); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, detail)); } catch (e) {}
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function cardData(i) {
    return { card: i + 1, week: WEEKS[Math.floor(i / 7)].name, mantra: CARDS[i][0], question: CARDS[i][1] };
  }

  /* ---------- One card a day ---------- */
  if (!customElements.get('umm-mantra-draw')) {
    customElements.define('umm-mantra-draw', class extends HTMLElement {
      connectedCallback() {
        if (this.built) return;
        this.built = true;
        var logo = this.dataset.logo || '';
        var deckUrl = this.dataset.deckUrl || '/products/21-day-transformation-mantra-deck-ritual';
        var guideUrl = this.dataset.guideUrl || '/products/21-day-transformation-guide';

        var root = el('div', 'ummm');
        var stage = el('div', 'ummm__stage');
        var deck = el('div', 'ummm__deck');
        for (var k = 0; k < 5; k++) {
          var b = el('span', 'ummm__back ummm__back--' + k);
          if (logo) { var im = el('img'); im.src = logo; im.alt = ''; im.width = 120; im.height = 67; b.appendChild(im); }
          deck.appendChild(b);
        }
        var drawBtn = el('button', 'ummm__drawbtn');
        drawBtn.type = 'button';
        drawBtn.setAttribute('aria-label', 'Draw a card');
        deck.appendChild(drawBtn);

        var card = el('div', 'ummm__card');
        card.hidden = true;
        var inner = el('div', 'ummm__inner');
        var back = el('div', 'ummm__back ummm__back--flip');
        if (logo) { var im2 = el('img'); im2.src = logo; im2.alt = ''; im2.width = 120; im2.height = 67; back.appendChild(im2); }
        var face = el('div', 'ummm__face');
        face.setAttribute('aria-live', 'polite');
        this.wk = el('p', 'ummm__wk');
        this.mantra = el('p', 'ummm__mantra');
        this.q = el('p', 'ummm__q');
        this.num = el('p', 'ummm__num');
        face.append(this.wk, this.mantra, this.q, this.num);
        inner.append(back, face);
        card.appendChild(inner);
        stage.append(deck, card);

        this.hint = el('p', 'ummm__hint', 'Breathe slowly. When you are ready, draw one card.');
        var drawLabel = el('button', 'ummm__drawlabel', 'Draw Your Card');
        drawLabel.type = 'button';

        var after = el('div', 'ummm__after');
        after.hidden = true;
        this.note = el('p', 'ummm__note');
        var how = el('p', 'ummm__how', 'Repeat it in water, aloud or silently, as the shower flows or the bath surrounds you. Carry the question through your day.');
        this.progress = el('p', 'ummm__progress');
        var links = el('div', 'ummm__links');
        var a1 = el('a', 'ummm__link ummm__link--primary', 'Hold the Full Deck'); a1.href = deckUrl;
        var a2 = el('a', 'ummm__link', 'The 21-Day Guide'); a2.href = guideUrl;
        links.append(a1, a2);
        after.append(this.note, how, this.progress, links);

        root.append(stage, this.hint, drawLabel, after);
        this.appendChild(root);
        this.els = { deck: deck, card: card, after: after, drawLabel: drawLabel };

        var self = this;
        function onDraw() { self.draw(); }
        drawBtn.addEventListener('click', onDraw);
        drawLabel.addEventListener('click', onDraw);

        var s = load();
        if (s.day === today() && typeof s.card === 'number' && CARDS[s.card]) this.show(s.card, false, true);
      }

      draw() {
        var s = load();
        if (s.day === today() && typeof s.card === 'number' && CARDS[s.card]) { this.show(s.card, true, true); return; }
        var drawn = Array.isArray(s.drawn) ? s.drawn.filter(function (n) { return n >= 0 && n < 21; }) : [];
        if (drawn.length >= 21) drawn = [];
        var pool = [];
        for (var i = 0; i < 21; i++) if (drawn.indexOf(i) === -1) pool.push(i);
        var pick = pool[Math.floor(Math.random() * pool.length)];
        drawn.push(pick);
        save({ day: today(), card: pick, drawn: drawn });
        this.show(pick, true, false);
        var d = cardData(pick);
        d.practice = drawn.length;
        track('umm_mantra_drawn', d);
        try { window.dispatchEvent(new CustomEvent('umm:mantra-drawn', { detail: d })); } catch (e) {}
      }

      show(i, animate, returning) {
        var d = cardData(i);
        var s = load();
        var count = Array.isArray(s.drawn) ? s.drawn.length : 1;
        this.wk.textContent = d.week;
        this.mantra.textContent = d.mantra;
        this.q.textContent = d.question;
        this.num.textContent = 'Card ' + d.card + ' of 21';
        this.note.textContent = returning ? 'Your mantra for today. A new card awaits you tomorrow.' : 'Your mantra for today.';
        this.progress.textContent = count >= 21 ? 'You have drawn all 21 cards. Tomorrow, the practice begins again.' : 'Your practice: ' + count + ' of 21 cards. Return tomorrow for your next.';

        var e = this.els;
        e.card.hidden = false;
        e.deck.classList.add('is-drawn');
        e.drawLabel.hidden = true;
        this.hint.hidden = true;
        this.classList.add('has-card');
        if (animate && !reduced()) {
          e.card.classList.remove('is-flipped');
          void e.card.offsetWidth;
          var c = e.card;
          setTimeout(function () { c.classList.add('is-flipped'); }, 60);
          setTimeout(function () { e.after.hidden = false; }, 900);
        } else {
          e.card.classList.add('is-flipped', 'no-anim');
          e.after.hidden = false;
        }
      }
    });
  }

  /* ---------- Sitewide tab + pop-up ---------- */
  if (!customElements.get('umm-mantra-float')) {
    customElements.define('umm-mantra-float', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        var self = this;
        this.tab = this.querySelector('[data-mm-tab]');
        this.hideBtn = this.querySelector('[data-mm-hide]');
        this.modal = this.querySelector('[data-mm-modal]');
        this.closeBtn = this.querySelector('[data-mm-close]');
        var hiddenUntil = 0;
        try { hiddenUntil = parseInt(localStorage.getItem('umm_mantra_tab_hidden') || '0', 10); } catch (e) {}
        if (Date.now() < hiddenUntil) return;

        var delay = (parseInt(this.dataset.delay, 10) || 8) * 1000;
        var shown = false;
        function reveal() {
          if (shown) return;
          shown = true;
          self.tab.parentElement.hidden = false;
          requestAnimationFrame(function () { self.classList.add('is-ready'); });
          window.removeEventListener('scroll', onScroll);
          self.maybeAutoOpen();
        }
        function onScroll() {
          var max = document.documentElement.scrollHeight - window.innerHeight;
          if (max > 0 && window.scrollY / max > 0.3) reveal();
        }
        setTimeout(reveal, delay);
        window.addEventListener('scroll', onScroll, { passive: true });

        this.tab.addEventListener('click', function () { self.open('tab'); });
        this.hideBtn.addEventListener('click', function () {
          try { localStorage.setItem('umm_mantra_tab_hidden', String(Date.now() + 7 * 864e5)); } catch (e) {}
          self.classList.remove('is-ready');
          self.tab.parentElement.hidden = true;
        });
        this.closeBtn.addEventListener('click', function () { self.close(); });
        this.modal.addEventListener('click', function (e) { if (e.target === self.modal) self.close(); });
        document.addEventListener('keydown', function (e) {
          if (self.modal.hidden) return;
          if (e.key === 'Escape') self.close();
          if (e.key === 'Tab') self.trap(e);
        });
        window.addEventListener('umm:mantra-open', function () { self.open('event'); });
      }

      maybeAutoOpen() {
        var mode = this.dataset.auto || 'desktop';
        if (mode === 'off') return;
        if (mode === 'desktop' && window.matchMedia('(max-width: 768px)').matches) return;
        var seen = false;
        try { seen = !!localStorage.getItem('umm_mantra_auto_seen'); } catch (e) { seen = true; }
        if (seen) return;
        var s = load();
        if (s.day === today()) return;
        try { localStorage.setItem('umm_mantra_auto_seen', '1'); } catch (e) {}
        this.open('auto');
      }

      open(source) {
        this.lastFocus = document.activeElement;
        this.modal.hidden = false;
        document.documentElement.classList.add('ummm-lock');
        var m = this.modal;
        requestAnimationFrame(function () { m.classList.add('is-open'); });
        var dlg = this.modal.querySelector('.ummm-dialog');
        if (dlg) {
          dlg.setAttribute('tabindex', '-1');
          dlg.style.outline = 'none';
          dlg.focus({ preventScroll: true });
        }
        track('umm_mantra_open', { source: source });
      }

      close() {
        this.modal.classList.remove('is-open');
        this.modal.hidden = true;
        document.documentElement.classList.remove('ummm-lock');
        if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
      }

      trap(e) {
        var f = Array.prototype.filter.call(this.modal.querySelectorAll('button, a[href]'), function (n) { return !n.hidden && n.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || !this.modal.contains(document.activeElement) || document.activeElement.classList.contains('ummm-dialog'))) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  window.UMMMantra = {
    cards: CARDS,
    weeks: WEEKS,
    open: function () { window.dispatchEvent(new CustomEvent('umm:mantra-open')); },
    today: function () { var s = load(); return s.day === today() && CARDS[s.card] ? cardData(s.card) : null; }
  };
})();
